import { FC } from "react";

import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

interface IChequeSettingsInfoSetupFieldsPanel {}
export const ChequeSettingsInfoSetupFieldsPanel: FC<
	IChequeSettingsInfoSetupFieldsPanel
> = ({}) => {
	return (
		<div style={{ padding: "0" }}>
			<EnhancedDropDownRHFWithLabel
				selectName="chequeFormat"
				label="Cheque Format"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Cheque-Format`}
				items={[
					{ label: "New Business Format", value: 500 },
					{ label: "Old Format", value: 600 },
					{ label: "New Personal Format", value: 400 },
					{ label: "Cheque Print Format", value: 100 },
					{ label: "CIC Format", value: 200 },
					{ label: "Customize Format", value: 300 },
				]}
				selectedItem={500}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="dateFormat"
				label="Date format"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Date-format`}
				items={[
					{ label: "YYYYMMDD", value: 300 },
					{ label: "MMDDYYYY", value: 200 },
					{ label: "DDMMYYYY", value: 100 },
				]}
				selectedItem={300}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="printDateIndicators"
				label="Print date indicators"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Print-date-indicators-list`}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="printAddress"
				label="Print Address"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Print-Address`}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="printChequeNo"
				label="Print Cheque No."
				labelPosition={LabelPosition.Top}
				// required
				testId={`Print-Cheque-No.`}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="printPaymentDate"
				label="Print Payment Date"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Print-Payment-Date`}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
		</div>
	);
};
